export const bikeImages = {
      STD:{
        602:{
          GBL:'ONRD-SPY-MY24-Ryker-600-000F1RB00-Studio-34FR-EU.png',
          CA:'ONRD-SPY-MY23-Ryker-600-000F1PA00-Studio-34FR-NA.png',
          QC:'ONRD-SPY-MY23-Ryker-600-000F1PA00-Studio-34FR-NA.png',
          US:'ONRD-SPY-MY23-Ryker-600-000F1PA00-Studio-34FR-NA.png',
          FR:'ONRD-SPY-MY24-Ryker-600-000F1RB00-Studio-34FR-EU.png',
          DE:'ONRD-SPY-MY24-Ryker-600-000F1RB00-Studio-34FR-EU.png',
          AU:'ryker-600.png',
          NZ:'ryker-600.png',
          JP:'ryker-600.png',
        },
        903:{          
          GBL:'ONRD-SPY-MY24-Ryker-900-000F2RB00-Studio-34FR-EU.png',
          CA:'ONRD-SPY-MY23-Ryker-900-000F2PA00-Studio-34FR-NA.png',
          QC:'ONRD-SPY-MY23-Ryker-900-000F2PA00-Studio-34FR-NA.png',
          US:'ONRD-SPY-MY23-Ryker-900-000F2PA00-Studio-34FR-NA.png',
          FR:'ONRD-SPY-MY24-Ryker-900-000F2RB00-Studio-34FR-EU.png',
          DE:'ONRD-SPY-MY24-Ryker-900-000F2RB00-Studio-34FR-EU.png',
          AU:'ryker-900.png',
          NZ:'ryker-900.png',
          JP:'ryker-900.png',
        },
      },
      SPORT:{
        903:{
          GBL:'ONRD-SPY-MY24-Ryker-Sport-000F5RB00-Studio-34FR-EU.png',
          CA:'ryker-sport.png',
          QC:'ryker-sport.png',
          US:'ryker-sport.png',
          FR:'ONRD-SPY-MY24-Ryker-Sport-000F5RB00-Studio-34FR-EU.png',
          DE:'ONRD-SPY-MY24-Ryker-Sport-000F5RB00-Studio-34FR-EU.png',
          AU:'ryker-sport.png',
          NZ:'ryker-sport.png',
          JP:'ryker-sport.png'
        },
      },
      AR:{
        903:{
          GBL:'ONRD-SPY-MY24-Ryker-Rally-000F3RB00-Studio-34FR-EU.png',
          CA:'ONRD-SPY-MY24-Ryker-Rally-000F3RA00-Studio-34FR-NA.png',
          QC:'ONRD-SPY-MY24-Ryker-Rally-000F3RA00-Studio-34FR-NA.png',
          US:'ONRD-SPY-MY24-Ryker-Rally-000F3RA00-Studio-34FR-NA.png',
          FR:'ONRD-SPY-MY24-Ryker-Rally-000F3RB00-Studio-34FR-EU.png',
          DE:'ONRD-SPY-MY24-Ryker-Rally-000F3RB00-Studio-34FR-EU.png',
          AU:'ryker-rally.png',
          NZ:'ryker-rally.png',
          JP:'ryker-rally.png'
        },
      }
    }


// WEBPACK FOOTER //
// ./src/pages/Selection/BikeImages.js